module.exports = __webpack_public_path__ + "img/BG_blue.e83c1278.gif";